<template>
  <div>
    <div class="bg-light p-3 mt-3 sidebar-sub-container" id="price_plans">
        <h3 class="sidebar-sub-container-headline">{{$t('vue.checkout.sidebar.priceplans.subscriptionParameter')}}
      </h3>

      <p>
          {{ $t('vue.checkout.sidebar.priceplans.subscriptionCost') }} {{ priceFormatted }}<br>
          {{ mileage }} {{ $t('vue.checkout.sidebar.priceplans.kmPerMonth') }}<br>
          {{ $t('vue.checkout.sidebar.priceplans.periodOfValidity', {period: pricePlan_selected.minimum_duration}) }}<br>

          <span class="sidebar-edit-vehicle" v-if="changeable"
                data-toggle="modal"
                data-target="#pricePlanModal"
                id="checkout_sidebar_duration_modal_trigger"
                dusk="checkout_sidebar_duration_modal_trigger"
          >
              {{ $t('vue.checkout.sidebar.priceplans.adjustSuscriptionParameter') }}
          <i class="far fa-pencil-alt"></i>
      </span>
      </p>


      <ul class="li-checkmark">
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.insurance') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.service') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.seasonWheels') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.admissionFee') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.traffictaxes') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.currentVignetted') }}
        </li>
        <li>
            <i class="fal fa-check text-success"></i>
            {{ $t('vue.checkout.sidebar.priceplans.moreDriver') }}
        </li>
      </ul>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="pricePlanModal" tabindex="-1" role="dialog" aria-labelledby="pricePlanModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <h3 class="modal-title sidebar-sub-container-headline" id="exampleModalLabel">
                  {{ $t('vue.checkout.sidebar.priceplans.justCar') }}
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">

            <div v-if="hasPricePlans">

              <div class="mb-1">
                <div class="form-group d-none d-md-block">
                    <label for="mileage-desktop" class="font-weight-bold">
                        {{ $t('vue.checkout.sidebar.priceplans.kilometerPackage') }}
                    </label>
                  <select name="mileage" id="mileage-desktop" class="form-control custom-select"
                          v-model="mileage_selected" @change="changeMileageAndAvailableDurations">
                      <option v-for="(mileage, index) in mileages" v-bind:value="mileage.mileage">
                          {{ mileage.mileage }}
                          {{ $t('vue.checkout.sidebar.priceplans.kmPerMonth') }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="mb-1">
                <div class="form-group d-none d-md-block">
                    <label for="duration-desktop" class="font-weight-bold">
                      {{ $t('vue.checkout.sidebar.priceplans.periodOfValidity', {period: pricePlan_selected.minimum_duration}) }}
                    </label>
                  <select name="duration" id="duration-desktop" class="form-control custom-select"
                          v-model="duration_selected" @change="changeDuration">
                      <option v-for="(duration, index) in durationOptions"
                              v-bind:value="duration.minimum_duration">
                          {{ duration.minimum_duration }}
                          {{ $t('vue.checkout.sidebar.priceplans.months') }}
                    </option>
                  </select>
                </div>
              </div>

              <p v-if="!fixedDuration" class="mb-0">
                  <i class="fas fa-check text-primary-cat2"></i>
                  {{ $t('vue.checkout.sidebar.priceplans.terminatable') }}
              </p>
              <p class="mb-4 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45); margin-bottom: 0px;"
                 v-if="isShortestDurationInSelectedMileage">
                <i class="fas fa-check text-primary-cat2"></i>
                <span>
                    {{ $t('vue.checkout.sidebar.priceplans.maxFlexibility') }}
                </span>
              </p>
              <p class="mb-4 text-primary-cat2 font-weight-bold" style="color: rgb(30, 30, 45); margin-bottom: 0px;"
                 v-else-if="savings > 0">
                <i class="fas fa-check text-primary-cat2"></i>
                <span>
                    {{ $t('vue.checkout.sidebar.priceplans.saveMoney', {amount: savingsFormatted}) }}
                </span>
              </p>

              <p class="font-weight-bold mb-0">
                  {{ $t('vue.checkout.sidebar.priceplans.allInclusivePrice') }}
              </p>

              <div v-if="hasValidCampaignPrice" class="strike-price-box">
                <p class="price-offer">
                    <span class="price">{{ campaignPrice }}</span>

                    / {{ $t('consumer.partials.subscriptions.activeTable.month') }}
                </p>
                <p class="strike-price">
                    {{ $t('vue.checkout.sidebar.priceplans.instead') }}
                  <span class="price">{{ strikePriceFormatted }}</span>
                </p>
              </div>

              <p v-else style="font-size: 1.6rem !important; margin-bottom: 0px;">
                  {{ priceFormatted }}
                  / {{ $t('consumer.partials.subscriptions.activeTable.month') }}
              </p>

              <p class="mb-0">
                  <i class="fas fa-check text-primary-cat2"></i>
                  {{ $t('vue.checkout.sidebar.priceplans.allInclusiveButFuel') }}
              </p>
              <p class="mb-4">
                  {{ $t('vue.checkout.sidebar.priceplans.priceInclusiveVAT') }}
              </p>

            </div>

            <div class="alert alert-warning" v-else>
                <p>
                    {{ $t('vue.checkout.sidebar.priceplans.error') }}
              </p>
            </div>

          </div>

          <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="changePricePlan">
                  {{ $t('vue.checkout.sidebar.priceplans.takeOver') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricePlans",
  props: {
    vehicleApiEndpoint: {
      type: String,
      required: true
    },
    fixedDuration: {
      type: Boolean,
      required: false,
      default: true
    },
    givenMileage: {
      type: Object,
      required: true
    },
    givenDuration: {
      type: Object,
      required: true
    },
    changeable: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      pricePlans: [],
      mileages: [],
      durations: {},
      mileage_selected: '',
      duration_selected: '',
      pricePlan_selected: '',
      stickyBuyBoxStyles: "none",
      csrf: document
          .querySelector ('meta[name="csrf-token"]')
          .getAttribute ("content"),
    }
  },

  computed: {
    mileage () {
      return this.pricePlan_selected.mileage
    },
    durationOptions () {
      return this.durations[this.mileage_selected]
    },
    priceFormatted () {
      return this.getFormattedPrice (this.price)
    },
    price () {
      if (this.pricePlan_selected.has_campaign_price && this.pricePlan_selected.campaign_price > 0) {
        return this.pricePlan_selected.campaign_price
      }
      return this.pricePlan_selected.price
    },
    strikePrice () {
      return this.pricePlan_selected.price
    },
    strikePriceFormatted () {
      return this.getFormattedPrice (this.strikePrice)
    },
    savingsFormatted () {
      return this.getFormattedPrice (this.savings)
    },
    savings () {
      let pricePlansForCurrentMileage = _.filter (this.pricePlans, o => {
        return o.mileage === this.mileage_selected
      })

      if (pricePlansForCurrentMileage.length === 0) {
        return 0
      }

      let mostExpensivePricePlan = _.maxBy (pricePlansForCurrentMileage, o => {
        return o.price
      })

      let comparePrice = mostExpensivePricePlan.price
      if (mostExpensivePricePlan.has_campaign_price && mostExpensivePricePlan.campaign_price > 0) {
        comparePrice = mostExpensivePricePlan.campaign_price
      }

      return comparePrice - this.price
    },
    hasPricePlans () {
      return this.pricePlans.length > 0
    },
    isShortestDurationInSelectedMileage () {
      let pricePlansForCurrentMileage = _.filter (this.pricePlans, o => {
        return o.mileage === this.givenMileage.mileage
      })

      let lowestPricePlan = _.minBy (pricePlansForCurrentMileage, o => {
        return o.minimum_duration
      })

      return lowestPricePlan.minimum_duration === this.givenDuration.months
    },
    hasValidCampaignPrice () {
      return this.pricePlan_selected.has_campaign_price
          && this.pricePlan_selected.price > this.pricePlan_selected.campaign_price
          && this.pricePlan_selected.campaign_price > 0
    },
    campaignPrice () {
      return this.getFormattedPrice (this.pricePlan_selected.campaign_price)
    }
  },

  methods: {
    changeMileageAndAvailableDurations () {
      let planWithCurrentDuration = _.find (this.pricePlans, o => {
        return o.mileage === this.mileage_selected && o.minimum_duration === this.duration_selected
      })

      if (typeof planWithCurrentDuration !== "undefined") {
        this.pricePlan_selected = planWithCurrentDuration
      } else {
        this.pricePlan_selected = this.lowestPricePlan (this.mileage_selected)
        this.duration_selected = this.pricePlan_selected.minimum_duration
      }
    },
    changeDuration () {
      this.pricePlan_selected = this.getPricePlanByMileageAndDuration (this.mileage_selected, this.duration_selected)
    },
    changePricePlan () {
      $ ('#pricePlanModal').modal ('hide')
      this.$emit ('price-plan-changed', this.pricePlan_selected)
    },
    getFormattedPrice (price) {
      const iso = typeof this.pricePlan_selected.currency !== "undefined" ? this.pricePlan_selected.currency.iso : "EUR"
      return new Intl.NumberFormat ('de-CH', {
        style: 'currency',
        currency: iso
      }).format (price)
    },
    getPricePlanByMileageIdAndDurationId (mileageId, durationId) {
      return _.find (this.pricePlans, o => {
        return o.mileage_id === mileageId && o.duration_id === durationId
      })
    },
    getPricePlanByMileageAndDuration (mileage, duration) {
      return _.find (this.pricePlans, o => {
        return o.mileage === mileage && o.minimum_duration === duration
      })
    },
    lowestPricePlan (mileage = null) {
      if (mileage !== null) {
        let pricePlansForGivenMileage = _.filter (this.pricePlans, o => {
          return o.mileage === mileage
        })
        let lowestPricePlanForGivenMileage = _.minBy (pricePlansForGivenMileage, o => {
          return o.price
        })

        if (typeof lowestPricePlanForGivenMileage !== "undefined" || lowestPricePlanForGivenMileage !== null) {
          return lowestPricePlanForGivenMileage
        }
      }
      return _.minBy (this.pricePlans, o => {
        return o.price
      })
    }
  },

  async created () {
    await axios.get (this.vehicleApiEndpoint + "?country=ch").then (r => {
      this.pricePlans = r.data.data.price_plans
    }).catch (e => {
      console.warn (e)
      this.pricePlans = []
    })

    let self = this
    let mileages = _.groupBy (this.pricePlans, 'mileage')

    _.forEach (mileages, (options, key) => {
      self.durations[key] = options

      let option = _.find (options, o => {
        return parseInt (o.mileage) === parseInt (key)
      })
      self.mileages.push ({
        key: option.mileage,
        mileage: option.mileage
      })
    })

    const givenPricePlan = _.find (this.pricePlans, o => {
      return o.minimum_duration === this.givenDuration.months && o.mileage === this.givenMileage.mileage
    })

    // Set values for the selected options
    this.pricePlan_selected = givenPricePlan
    this.duration_selected = givenPricePlan.minimum_duration
    this.mileage_selected = givenPricePlan.mileage
  }
}
</script>

<style scoped lang="scss">
  i, .text-primary-cat2 {
    color: #801977!important;
  }
</style>
